// extracted by mini-css-extract-plugin
export default {"container":"page-email-unsubscribe_container__VJO-5","languageSwitcher":"page-email-unsubscribe_languageSwitcher__6J5RV","content":"page-email-unsubscribe_content__Wv8ws"};